import React from 'react';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'muted' | 'primary';

interface StatusBadgeProps {
  label: string;
  variant: BadgeVariant;
  dot?: boolean;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ label, variant, dot = false, size = 'md' }: StatusBadgeProps) {
  const variantClass: Record<BadgeVariant, string> = {
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    info: 'badge-info',
    muted: 'badge-muted',
    primary: 'bg-primary/10 text-primary border border-primary/20',
  };

  const dotColor: Record<BadgeVariant, string> = {
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
    info: 'bg-info',
    muted: 'bg-muted-foreground',
    primary: 'bg-primary',
  };

  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-600 ${variantClass[variant]} ${sizeClass}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dotColor[variant]}`} />}
      {label}
    </span>
  );
}